// extracted by mini-css-extract-plugin
export default {"thanks":"Thanks_thanks__TKhCo","thanks__text":"Thanks_thanks__text__uLZgt","thanks__login":"Thanks_thanks__login__tZfWB"};